<template>
  <div v-if="needEventProcessor" />
</template>
<script>
  import {
    FLUSH_EVENT,
    ON_CLICK_CELL,
    ON_DISPLAY_BAND,
  } from '@/common/resources/const'
  import _ from 'lodash'
  import { eventBodyListParser } from '@/common/utils/gnb.fp'
  import { sendUiEventLog } from '@/common/utils/log.v2.request'

  export default {
    name: 'EventProcessor',
    data() {
      return {
        eventQueue: [],
        timer: 5000,
        eventTimer: null,
        needEventProcessor: true,
      }
    },
    watch: {
      eventQueue() {
        clearTimeout(this.eventTimer)
        this.eventTimer = setTimeout(() => {
          this.flushEventQueue()
        }, this.timer)
      },
    },
    mounted() {
      this.$events.$on(ON_DISPLAY_BAND, (event) => {
        this.addEvent(event)
      })
      this.$events.$on(ON_CLICK_CELL, (event) => {
        this.addEvent(event)
      })
      this.$events.$on(FLUSH_EVENT, () => {
        this.flushEventQueue()
      })
    },
    created() {
      this.setVisibleState()
    },
    methods: {
      deepCopy(list) {
        return _.map(list, _.clone)
      },
      flushEventQueue() {
        if (this.eventQueue.length === 0) {
          clearTimeout(this.eventTimer)
          return
        }
        const copyList = this.deepCopy(this.eventQueue)
        this.eventQueue = []
        this.sendEventLogList(copyList)
      },
      addEvent(event) {
        this.eventQueue.push(event)
      },
      sendEventLogList(list) {
        if (list.length === 0) return

        return sendUiEventLog({ list: list.map(eventBodyListParser) })
      },
      setVisibleState() {
        const disabledPathList = [
          '/conference/live',
          '/conference/index',
          '/conference/index.html',
          '/conference/auth-from-code',
        ]
        this.needEventProcessor = !disabledPathList.includes(location.pathname)
      },
    },
  }
</script>
